const WORKSPACE_MANAGER = 'WORKSPACE_MANAGER';
const WORKSPACE_VIEWER = 'WORKSPACE_VIEWER';

export default {
  WORKSPACE_MANAGER,
  WORKSPACE_VIEWER,
};
